import { useLazyQuery } from "@apollo/client";
import { useContext, useEffect } from "react";

import { ConfigLabels } from "../utils/Enum.types";

import { AppContext } from "../context/context";
import
{
    ConfigQuery,
    GetSwConfigVariablesResult,
    GetSwConfigVariablesVar,
    SwConfigQueryType,
} from "../components/modules/asset/masters/items/configurations/queries/type";
import useUrlParams from "./useUrlParams";
import { GetSwConfigVariables } from "../components/modules/asset/masters/items/configurations/queries/queries";

export type ConfigKey = ConfigLabels;



const useSwConfigVars = ( { intValue, queryType, strValue }: ConfigQuery ) =>
{
    const { customer_id } = useUrlParams();

    const { state } = useContext( AppContext );
    const [ GetSwVariablesData, { data, loading, error } ] = useLazyQuery<
        GetSwConfigVariablesResult,
        GetSwConfigVariablesVar
    >( GetSwConfigVariables );

    useEffect( () =>
    {
        const fetchData = async () =>
        {
            try
            {
                if ( customer_id || state.customerId )
                {
                    GetSwVariablesData( {
                        variables: {
                            customerID: customer_id ? customer_id : state.customerId,
                            input: {
                                queryType,
                                intValue,
                                strValue,
                            },
                        },
                    } );
                }
            } catch ( err )
            {
                console.error( ( err as Error ).message );
            }
        };
        fetchData();
    }, [ customer_id, state.customerId, GetSwVariablesData ] );

    return { configData: { data, loading, error } };
};

export default useSwConfigVars;
